// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

const Text = styled<any, Theme>('div')`
  color: ${props => props.theme.form.text.color};
`;

export default Text;
